import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';

import { appTooltipId } from '../utils';

//
// Mounted once, at the app root: every plain-text tooltip in the app anchors to
// this instance through appTooltipProps(), so delay and placement are defined here only.
// Portalled out of the React tree because ContentZoomer scales its subtree, and a
// transformed ancestor would both re-anchor and scale a position:fixed tooltip.
//
function AppTooltip() {
  return createPortal(
    <Tooltip
      id={appTooltipId}
      place="top"
      delayShow={200}
      delayHide={100}
      positionStrategy="fixed"
    />,
    document.body,
  );
}

export default AppTooltip;
